// Bibliotecas
import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Card, CardBody, Collapse } from 'reactstrap';

// Componentes
import ImportGroup from './ImportGroups';
import ImportParticipant from './ImportParticipant';
import SectionComponent from '../../Apps/Personalization/SectionComponent';

export default function ModalImportWrapper(props) {
  const { isOpen, toggle, idEvent, getAllParticipants, token } = props;

  const [collapseGroupIsOpen, setCollapseGroupIsOpen] = useState(false);
  const [collapseLoginIsOpen, setCollapseLoginIsOpen] = useState(false);
  const [activeImport, setActiveImport] = useState(false);

  // Fecha os collapses e o modal
  function toggleBackdrop() {
    setCollapseGroupIsOpen(false);
    setCollapseLoginIsOpen(false);
    toggle();
  }

  // Alterna o collapse de importação de participantes
  function toggleCollapseLogin() {
    if (activeImport) return;
    setCollapseGroupIsOpen(false);
    setCollapseLoginIsOpen(!collapseLoginIsOpen);
  }

  // Alterna o collapse de alteração de grupos
  function toggleCollapseGroup() {
    if (activeImport) return;
    setCollapseGroupIsOpen(!collapseGroupIsOpen);
    setCollapseLoginIsOpen(false);
  }

  return (
    <Modal isOpen={isOpen} toggle={toggleBackdrop} autoFocus centered>
      <ModalHeader toggle={toggleBackdrop}>Importar Participantes</ModalHeader>
      <ModalBody className="m-1 p-0">
        <Card className="p-1">
          <CardBody className="m-1 p-2">
            <div>
              <Row style={{ marginBottom: 10 }}>
                <SectionComponent
                  sectionName="Criar/Atualizar participantes"
                  setIsOpen={toggleCollapseLogin}
                  isOpen={collapseLoginIsOpen}
                />
              </Row>
              <Collapse isOpen={collapseLoginIsOpen}>
                <ImportParticipant
                  isOpen={isOpen}
                  toggle={toggleBackdrop}
                  active={setActiveImport}
                  getAllParticipants={getAllParticipants}
                  token={token}
                  idEvent={idEvent}
                />
              </Collapse>
            </div>
            <div>
              <Row style={{ marginBottom: 10 }}>
                <SectionComponent
                  sectionName="Alterar Grupos dos Participantes"
                  setIsOpen={toggleCollapseGroup}
                  isOpen={collapseGroupIsOpen}
                />
              </Row>
              <Collapse isOpen={collapseGroupIsOpen}>
                <ImportGroup
                  isOpen={isOpen}
                  toggle={toggleBackdrop}
                  active={setActiveImport}
                  idEvent={idEvent}
                  token={token}
                  getAllParticipants={getAllParticipants}
                />
              </Collapse>
            </div>
          </CardBody>
        </Card>
      </ModalBody>
    </Modal>
  );
}
